module.exports = __webpack_public_path__ + "static/media/hf_superior.c8f48d70.jpg";